import type { ReactNode } from 'react';
import { createContext, use } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppBundleFromUrl } from '../utils/navigation';
import type { AppBundle } from '../utils/app-bundles';

export const ActiveAppContext = createContext<AppBundle | null | undefined>(undefined);

function useActiveBundleInternal() {
  const location = useLocation();
  return getAppBundleFromUrl(location.pathname);
}

export function useActiveBundle() {
  const context = use(ActiveAppContext);
  if (context === undefined) {
    throw new Error('useActiveBundle must be used within an ActiveAppContext');
  }
  return context;
}

export function ActiveAppContextProvider({ children }: { children: ReactNode }) {
  const activeApp = useActiveBundleInternal();

  return <ActiveAppContext.Provider value={activeApp}>{children}</ActiveAppContext.Provider>;
}
